export enum PRODUCT_TYPE_ENUM {
  equity = 'equity',
  advisory = 'advisory',
}
